module.exports = __webpack_public_path__ + "img/logo-white.870bd158.svg";